var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.8842 8.24463H10.9925C9.74455 8.24463 8.73633 9.25285 8.73633 10.5008V62.3925C8.73633 63.6404 9.74455 64.6486 10.9925 64.6486H62.8842C64.1321 64.6486 65.1403 63.6404 65.1403 62.3925V10.5008C65.1403 9.25285 64.1321 8.24463 62.8842 8.24463ZM56.3695 24.7075H51.8642C48.3319 24.7075 47.648 26.3856 47.648 28.8532V34.2892H56.0804L54.9805 42.7991H47.648V64.6486H38.8561V42.8062H31.5024V34.2892H38.8561V28.0142C38.8561 20.7311 43.3049 16.7616 49.8055 16.7616C52.9218 16.7616 55.5939 16.9943 56.3765 17.1001V24.7075H56.3695Z",
    fill: "#FDF6EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.94cf0f9b54f369663e78559ca0230afe.svg";
export { ForwardRef as ReactComponent };